import { APP_FLAVOR } from "../env/appFlavor.js";

export type CrazyGamesBannerReadiness = "unknown" | "ready" | "blocked";

export const CRAZY_GAMES_BANNER_READINESS_EVENT = "crazygamesbannerreadinesschange";

let bannerReadiness: CrazyGamesBannerReadiness = "unknown";

export function getCrazyGamesBannerReadiness(): CrazyGamesBannerReadiness {
  return bannerReadiness;
}

export function isCrazyGamesBannerReady(): boolean {
  return bannerReadiness === "ready";
}

export function shouldReserveCrazyGamesBannerSlot(): boolean {
  return APP_FLAVOR === "dev" || bannerReadiness !== "blocked";
}

export function shouldShowCrazyGamesBannerPlaceholder(): boolean {
  return APP_FLAVOR === "dev" || bannerReadiness === "ready";
}

export function setCrazyGamesBannerReadiness(next: CrazyGamesBannerReadiness): void {
  if (bannerReadiness === next) return;
  bannerReadiness = next;
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CRAZY_GAMES_BANNER_READINESS_EVENT, { detail: next }));
}

export function subscribeCrazyGamesBannerReadinessChange(listener: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(CRAZY_GAMES_BANNER_READINESS_EVENT, listener);
  return () => window.removeEventListener(CRAZY_GAMES_BANNER_READINESS_EVENT, listener);
}

export function resetCrazyGamesBannerReadinessForTests(): void {
  bannerReadiness = "unknown";
}

export function isCrazyGamesBannerBlockedError(error: unknown): boolean {
  const record = error as { code?: unknown; message?: unknown } | null;
  return (
    record?.code === "bannersDisabledBasicLaunch" ||
    (typeof record?.message === "string" && record.message.includes("Banners are disabled during basic launch"))
  );
}
